import React, { useContext, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import './Header.css';

const Header = () => {
  const { currentUser, logout, userProfile } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/');
      setIsMenuOpen(false);
    } catch (error) {
      console.error('Erreur lors de la déconnexion:', error);
    }
  };

  const handleLogin = () => {
    if (typeof window.openAuthModal === 'function') {
      window.openAuthModal();
    } else {
      console.warn("La modal d'authentification n'est pas disponible.");
    }
  };

  const userLinks = [
    { path: '/dashboard', label: 'Espace client' },
    userProfile?.role === 'practitioner' && { path: '/practitioner', label: 'Espace PRO' },
    userProfile?.role === 'admin' && { path: '/admin', label: 'Administration' },
  ].filter(Boolean);

  return (
    <header className="main-header">
      <div className="container">
        <div className="logo">
          <Link to="/">
            <h1>NaturoBooK</h1>
          </Link>
        </div>

        {/* Bouton Menu Burger */}
        <button 
          className="mobile-menu-btn" 
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Ouvrir le menu"
        >
          ☰
        </button>

        {/* Menu */}
        <nav className={`nav-menu ${isMenuOpen ? "open" : ""}`}>
          <ul>
            <li>
              <Link 
                to="/" 
                className={location.pathname === '/' ? 'active' : ''}
                onClick={() => setIsMenuOpen(false)}
              >
                Accueil
              </Link>
            </li>

            {!currentUser ? (
              <li>
                <button 
                  id="login-btn" 
                  className="login-btn" 
                  onClick={() => { handleLogin(); setIsMenuOpen(false); }}
                  aria-label="Se connecter"
                >
                  Connexion
                </button>
              </li>
            ) : (
              <>
                {userLinks.map(({ path, label }) => (
                  <li key={path}>
                    <Link 
                      to={path} 
                      className={location.pathname === path ? 'active' : ''}
                      onClick={() => setIsMenuOpen(false)}
                    >
                      {label}
                    </Link>
                  </li>
                ))}
                <li>
                  <button 
                    onClick={handleLogout} 
                    className="logout-btn" 
                    aria-label="Se déconnecter"
                  >
                    Déconnexion
                  </button>
                </li>
              </>
            )}
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
